module.exports = __webpack_public_path__ + "static/img/event6.c147626.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event6.png
// module id = HrS4
// module chunks = 1